import { render, staticRenderFns } from "./cartRullingItems.vue?vue&type=template&id=2ebcab49"
import script from "./cartRullingItems.vue?vue&type=script&lang=js"
export * from "./cartRullingItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports